import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppNavigation } from '../../hooks/useAppNavigation';
import { useAuth } from '../../hooks/useAuth';
import { useCart } from '../../hooks/useCart';
import { useMenus } from '../../hooks/useMenus';
import { useMobile } from '../../hooks/useMobile';
import { useTheme } from '../../hooks/useTheme';

import { LAYOUT_GRID, LAYOUT_LIST } from '../../provider/MenuProvider';

import { ReactComponent as LayoutGrid } from '../../icons/layout-grid.svg';
import { ReactComponent as LayoutList } from '../../icons/layout-list.svg';

import './header.scss';

import CartTotal from '../cart-total/CartTotal';
import { Button } from '../common/button/Button';
import Search from '../common/search/Search';
import ThemeToggle from '../theme-toggle/ThemeToggle';

const Header = () => {
  const { user, guestEmail } = useAuth();
  const navigate = useNavigate();
  const { showAppHeader, showSearch } = useAppNavigation();
  const isLoggedIn = user && !user.isAnonymous;
  const isMobile = useMobile();
  const { menuLayout, setMenuLayout } = useMenus();
  const { getThemeVariable } = useTheme();
  const backgroundColor = useMemo(
    () => getThemeVariable('background-secondary'),
    [getThemeVariable]
  );
  const textColor = useMemo(() => getThemeVariable('text-primary'), [getThemeVariable]);
  const { cartTotal } = useCart();
  const menuLayoutEnabled = false;

  const greeting = isLoggedIn
    ? { label: 'Welcome back!', name: `Hi, ${user.displayName || user.email}` }
    : { label: 'Because good food shouldn\'t wait.', name: 'Instant Meals' };

  return (
    <>
      {!showAppHeader && <div />}
      {showAppHeader && (
        <div className="header">
          <div>
            <div className="header__welcome">
              {isLoggedIn ? (
                <>
                  <span className="header__welcome-subtitle">{greeting.label}</span>
                  <span className="header__welcome-title">{greeting.name}</span>
                </>
              ) : (
                <>
                  <span className="header__welcome-title">{greeting.name}</span>
                  <span className="header__welcome-subtitle">{greeting.label}</span>
                </>
              )}
            </div>
            {!isLoggedIn && !guestEmail && !isMobile && (
              <Button
                onClick={() => navigate('/login')}
                className="header__sign-in"
                style={{ width: 'auto', background: '#e53935', borderColor: '#e53935' }}
              >
                <span>Sign in</span>
              </Button>
            )}
            {!isMobile && (
              <div className="header__theme-toggle">
                <ThemeToggle />
              </div>
            )}
            <CartTotal total={cartTotal} />
          </div>
          {showSearch && isMobile && (
            <div className="header__search">
              <Search />
              {menuLayoutEnabled && menuLayout === LAYOUT_GRID && (
                <LayoutList
                  key={LAYOUT_GRID}
                  onClick={() => setMenuLayout(LAYOUT_LIST)}
                  style={{ background: backgroundColor, color: textColor }}
                />
              )}
              {menuLayoutEnabled && menuLayout === LAYOUT_LIST && (
                <LayoutGrid
                  key={LAYOUT_LIST}
                  onClick={() => setMenuLayout(LAYOUT_GRID)}
                  style={{ background: backgroundColor, color: textColor }}
                />
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Header;
